import { ProductApiResponse } from './../models/product-api-response.model';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from '../models/product.model';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  constructor(
    private httpClient: HttpClient,
    private baseService: BaseService
  ) {}

  getProduct(code: string): Observable<Product> {
    const url = `${this.baseService.hostDomain}/api/products/${code}`;
    return this.httpClient
    .get<Product>(url)
    .pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Buscando los productos');
        return [];
      })
    );
  }
  getProducts(
    page?: number,
    limit?: number,
    sort?: string,
    viewOnlyActive?: boolean
  ): Observable<ProductApiResponse> {
    const url = `${this.baseService.hostDomain}/api/products`;
    const data: any = {};
    if (page) { data.page = page; }
    if (limit) { data.limit = limit; }
    if (sort) { data.sort = sort; }
    if (viewOnlyActive) { data.viewOnlyActive = viewOnlyActive; }
    return this.httpClient
      .get<ProductApiResponse>(url, { params: data })
      .pipe(
        catchError(err => {
          this.baseService.handleError(err, 'Buscando los productos');
          return [];
        })
      );
  }

  saveProduct(product: Product) {
    const url = `${this.baseService.hostDomain}/api/products`;
    return this.httpClient
      .post(url, product)
      .pipe(
        catchError(err => {
          this.baseService.handleError(err, `Guardando el producto ${product.productCode}`);
          return [];
        })
      );
  }
}
